import { ShipCountList } from "./ShipCountList";
import {Target} from "./Target";

export class GetAvailableMissionRequest {
    ships: ShipCountList[];
    target_model: string;
    target: Target;
}
